<script>
import { adminPanelMixin } from '@mixins/admin-panel-mixin.js';
import {
  adminPanelComputed,
  adminPanelMethods,
  exerciseComputed,
  exerciseMethods,
} from '@state/helpers';

export default {
  components: {},
  props: {
    step: {
      type: Object,
      required: true,
    },
    stepIndex: {
      type: Number,
      required: true,
    },
    hideControls: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [adminPanelMixin],
  data() {
    return {
      placeholder: require('@assets/images/placeholder-photo-upload.svg'),
      controlsVisible: false,
    };
  },
  computed: {
    ...adminPanelComputed,
    ...exerciseComputed,
    coverPhotoUrl() {
      return this.step.mediaAssets &&
        this.step.mediaAssets.coverPhoto &&
        this.step.mediaAssets.coverPhoto.url
        ? this.step.mediaAssets.coverPhoto.url
        : this.placeholder;
    },
  },
  mounted() {},
  methods: {
    ...adminPanelMethods,
    ...exerciseMethods,
    moveUp(step, index) {
      const currentStepIndex = this.selectedExercise.steps.findIndex(
        (item) => item.order === step.order
      );
      if (currentStepIndex > 0) {
        this.setMoveStepUp({ step, index });
      }
    },
    moveDown(step, index) {
      const currentStepIndex = this.selectedExercise.steps.findIndex(
        (item) => item.order === step.order
      );
      if (currentStepIndex < this.selectedExercise.steps.length - 1) {
        this.setMoveStepDown({ step, index });
      }
    },
    handleDupe(step) {
      this.setAddStep({
        ...step,
        order: this.selectedExercise.steps.length + 1,
      });
    },
    handleEdit(step, index) {
      this.setSelectedStep({ step, index });
      if (
        this.panelContent &&
        this.panelContent.data.componentLeft.name === 'ExerciseDetail'
      ) {
        this.setPanelContent({
          ...this.panelContent,
          data: {
            ...this.panelContent.data,
            componentRight: {
              name: 'ExerciseStepForm',
              showPanelDetail: true,
              exerciseStep: this.selectedStep,
            },
          },
        });
      } else {
        this.showAdminPanel('ExerciseStepForm', { step, index });
      }
    },
    handleDelete(i) {
      this.setRemoveStep(i);
    },
    async showAdminPanel(component, data = null, size = '') {
      await this.setPanelContent(this.getPanelContent(component, data, size));
      this.setShowAdminPanel();
    },
  },
};
</script>

<template>
  <div
    class="step-item"
    @mouseover="controlsVisible = true"
    @mouseleave="controlsVisible = false"
  >
    <div class="step-icon">
      <svg width="16" height="6" viewBox="0 0 16 6" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 0h16v2H0V0zm16 6H0V4h16v2z" fill="#000"/></svg>
    </div>
    <div class="step-thumbnail">
      <img :src="coverPhotoUrl" />
    </div>
    <div class="step-content">
      <span>
        <div class="step-title">
          <h3
            >{{ step.title }} <small>{{ step.duration }}</small></h3
          >
        </div>
        <div class="step-description">
          <p>{{ step.description }}</p>
        </div>
      </span>
      <div class="btn-group" v-if="controlsVisible && !hideControls">
        <BaseButton
          type="button"
          class="btn-primary btn-clear"
          @click="moveUp(step, stepIndex)"
        >
          <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-arrow'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.178 6.519l5.196-4.935 5.196 4.935" stroke="#030C16" stroke-width="2"/><path d="M6.44 3.416v10" stroke="#030C16" stroke-width="2" stroke-linecap="square"/></svg>
          Move Up
        </BaseButton>
        <span class="divider-vertical">&nbsp;</span>
        <BaseButton
          type="button"
          class="btn-primary btn-clear"
          @click="moveDown(step, stepIndex)"
        >
          <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-arrow'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.608 8.481l5.196 4.935L12 8.481" stroke="#030C16" stroke-width="2"/><path d="M6.871 11.584v-10" stroke="#030C16" stroke-width="2" stroke-linecap="square"/></svg>
          Move Down
        </BaseButton>
        <span class="divider-vertical">&nbsp;</span>
        <BaseButton
          type="button"
          class="btn-primary btn-clear"
          @click="handleDupe(step)"
        >
          <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'btn-icon icon-copy'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.876.4H2.296C1.053.4.034 1.43.034 2.69v16.037h2.264V2.691h13.579V.4zm3.394 4.582H6.823c-1.245 0-2.263 1.03-2.263 2.29V23.31c0 1.26 1.018 2.291 2.263 2.291H19.27c1.245 0 2.264-1.03 2.264-2.29V7.272c0-1.26-1.019-2.291-2.264-2.291zM6.823 23.309H19.27V7.273H6.823v16.036z" fill="#2F70DE"/></svg>
          Duplicate
        </BaseButton>
        <span class="divider-vertical">&nbsp;</span>
        <BaseButton
          type="button"
          class="btn-primary btn-clear"
          @click="handleDelete(stepIndex)"
        >
          <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'btn-icon icon-trash'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 1H14v2H0V1h3.5l1-1h5l1 1zM3 18c-1.1 0-2-.9-2-2V4h12v12c0 1.1-.9 2-2 2H3z" fill="#000"/></svg>
          Delete
        </BaseButton>
        <span class="divider-vertical">&nbsp;</span>
        <BaseButton
          type="button"
          class="btn-primary btn-clear"
          @click="handleEdit(step, stepIndex)"
        >
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'btn-icon icon-edit'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.71 3.13c.39.39.39 1.02 0 1.41l-1.83 1.83-3.75-3.75L13.96.79a.996.996 0 011.41 0l2.34 2.34zM0 18.5v-3.75L11.06 3.69l3.75 3.75L3.75 18.5H0z" fill="#030C16"/></svg>
          Edit
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.step-item {
  align-items: center;
  border-bottom: 1px solid $color-list-step-border;
  display: flex;
  flex-direction: row;
  padding: 2rem 0;

  &:active,
  &:focus {
    background-color: $color-off-white;
  }

  &:hover {
    background-color: $color-off-white;
    cursor: move;
  }

  &:first-of-type {
    border-top: 1px solid $color-list-step-border;
  }

  .step-content {
    display: flex;
    justify-content: space-between;
    width: 87%;
  }

  .step-icon {
    align-items: center;
    display: flex;
    height: 2.5rem;
    justify-content: center;
    margin-right: 1rem;
    width: 2.5rem;
  }

  .step-thumbnail {
    height: 6rem;
    margin-right: 3.4rem;
    width: 10rem;

    img {
      width: 100%;
    }
  }

  .step-title h3 {
    color: $color-heading-text;
    display: flex;
    flex-direction: column;

    small {
      color: $color-medium-gray-alt;
      display: block;
      font-size: 1.2rem;
      font-weight: 800;
      letter-spacing: 0.1px;
      line-height: 1;
      text-transform: uppercase;
    }
  }

  .btn-group {
    align-items: center;
    display: flex;

    .divider-vertical {
      border-left: 1px solid $color-medium-gray;
      height: 4rem;
    }

    .btn-clear {
      align-items: center;
      color: black;
      display: flex;

      &:active {
        background: rgba($color-white-wo-rgb, 0.1);
        color: black;
      }

      &:focus {
        background: transparent;
        color: black;
      }
    }

    .btn-icon {
      margin-right: 0.6rem;

      path {
        fill: black;
      }
    }

    .icon-arrow,
    .icon-copy,
    .icon-trash .icon-edit {
      margin-right: 0.6rem;
      width: 1.6rem;
    }
  }
}
</style>
